import {Inject, injectable} from 'inversify-props';

import {ISettingsProvider} from '@/services/settings/ISettingsProvider';
import {ILocalSettingsService} from '@/services/settings/ILocalSettingsService';
import {ISettingsService} from '@/services/settings/ISettings.service';
import {Setting, Theme} from '@/services/settings/Settings.types';

@injectable()
export class SettingsService implements ISettingsService {

  @Inject(Symbol.for('ILocalSettingsService'))
  private localSettingsService!: ILocalSettingsService;

  private defaultValues: Map<Setting, any> = new Map<Setting, any>([
    [Setting.RemoteAddress, null],
    [Setting.Secured, null],
    [Setting.Token, null],
    [Setting.Theme, Theme.Light],
    [Setting.HideAntennaCheck, false],
    [Setting.WidgetsDisabled, []],
  ]);

  private settingsLocation: Map<Setting, ISettingsProvider> = new Map<Setting, ISettingsProvider>([
    [Setting.RemoteAddress, this.localSettingsService],
    [Setting.Secured, this.localSettingsService],
    [Setting.Token, this.localSettingsService],
    [Setting.Theme, this.localSettingsService],
    [Setting.HideAntennaCheck, this.localSettingsService],
    [Setting.WidgetsDisabled, this.localSettingsService],
    [Setting.WidgetsOrder, this.localSettingsService],
  ]);

  public set(setting: Setting, value: any): void {
    const settingsProvider = this.settingsLocation.get(setting);

    if (settingsProvider === undefined) {
      throw new Error(`settings provider not defined for '${setting}'`);
    }

    settingsProvider.set(setting, value);
  }

  public get(setting: Setting): any | null {
    const settingsProvider = this.settingsLocation.get(setting);

    if (settingsProvider === undefined) {
      throw new Error(`settings provider not defined for '${setting}'`);
    }

    const value = settingsProvider.get(setting);

    if (value !== undefined && value !== null) {
      return value;
    } else {
      return this.defaultValues.get(setting);
    }
  }

  public clear(setting: Setting): void {
    const settingsProvider = this.settingsLocation.get(setting);

    if (settingsProvider === undefined) {
      throw new Error(`settings provider not defined for '${setting}'`);
    }

    return settingsProvider.clear(setting);
  }
}

